import React from "react";
import PropTypes from "prop-types";

import { companyUrl } from "views_shared/app/javascript/utils/urls";
import { HighlightedText, highlightValue } from "../../source_directory/HighlightAttribute";
import splitHeadlineHighlight from "./headlineHighlight";

const COMPANY_LINK_STYLE = { color: "#4d5357", textDecoration: "underline" };

function CompanyLink({ job, withSeparator, children }) {
  if (!job.company) return null;

  return (
    <>
      {withSeparator ? " at " : ""}
      {job.company_slug ? (
        <a href={companyUrl({ slug: job.company_slug, migrate_id: job.company_migrate_id })} style={COMPANY_LINK_STYLE}>
          {children}
        </a>
      ) : (
        children
      )}
    </>
  );
}

CompanyLink.propTypes = {
  job: PropTypes.shape({
    company: PropTypes.string,
    company_slug: PropTypes.string,
    company_migrate_id: PropTypes.number,
  }).isRequired,
  withSeparator: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

// jobs.title/jobs.company are faceting-only (never highlighted). headline is the searchable
// "<title> at <company>" equivalent, so on a headline match render the highlighted title segment
// followed by the company as its own link (the match may fall in either segment); otherwise render
// the plain linked job title/company.
export default function ExpertJobLine({ hit, job, headlineMatched }) {
  if (headlineMatched) {
    const { title, company } = splitHeadlineHighlight(highlightValue(hit, "headline"));

    if (!company) {
      return <HighlightedText markup={title} />;
    }

    return (
      <>
        <HighlightedText markup={title} />
        {job?.company ? (
          <CompanyLink job={job} withSeparator={title !== ""}>
            <HighlightedText markup={company} />
          </CompanyLink>
        ) : (
          <>
            {title !== "" ? " at " : ""}
            <HighlightedText markup={company} />
          </>
        )}
      </>
    );
  }

  if (!job) return null;

  return (
    <>
      {job.title}
      <CompanyLink job={job} withSeparator={!!job.title}>
        {job.company}
      </CompanyLink>
    </>
  );
}

ExpertJobLine.propTypes = {
  hit: PropTypes.instanceOf(Object).isRequired,
  job: PropTypes.shape({
    title: PropTypes.string,
    company: PropTypes.string,
    company_slug: PropTypes.string,
    company_migrate_id: PropTypes.number,
  }),
  headlineMatched: PropTypes.bool,
};
